import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

const DEFAULT_TIMEOUT_SECONDS = 30;

export const fetchNewCenturyHealthQuestionnaire = async (
  orderId: string,
  timeoutSeconds: number = DEFAULT_TIMEOUT_SECONDS,
): Promise<void> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutSeconds * 1000);

  const request = async () => {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("No token found");
    }
    const response = await fetch(
      API_ENDPOINTS.NEW_CENTURY_HEALTH_QUESTIONNAIRE,
      {
        method: "POST",
        signal: controller.signal,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          identifier: orderId.trim(),
        }),
      },
    );
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  };

  try {
    await request();
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      const timeoutError = new Error("Request timed out");
      logError(timeoutError, "Error fetching New Century Health questionnaire");
      throw timeoutError;
    }
    logError(error as Error, "Error fetching New Century Health questionnaire");
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};
